/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as ActionTypes from './ActionTypes';

const initialState = {
  mcoClaimsSearchObj: {},
  errorMsgMcoClaims: [],
  planType: [],
  quarter: '',
  rebateProgramName: '',
  rebateProgram: [],
  isLoading: false,
  manufacturerList: [],
  isMfgChecked: true,
  searchResult: [],
  selectedOption: 'ndc',
  uraType: 'inv',
  setRebateProgram: '',
  displayObj: {
    planType: [],
    quarter: '',
    rebateProgramName: '',
    rebateProgrameName: '',
    rebateProgram: [],
    isMfgChecked: true,
    searchResult: [],
    selectedOption: 'ndc',
    uraType: 'inv',
    setRebateProgram: '',
  },
};

const reducer = (state = initialState, Actions) => {
  switch (Actions.type) {
    case ActionTypes.GET_MCO_CLAIMS_SEARCH_OBJ:
      return { ...state, mcoClaimsSearchObj: Actions.screenData };
    case ActionTypes.IS_LOADING:
      return { ...state, isLoading: Actions.isLoading };
    case ActionTypes.GET_ERROR_MSG_MCO_CLAIMS:
      return { ...state, errorMsgMcoClaims: Actions.payload };
    case ActionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: Actions.payload };
    // case ActionTypes.GET_REBATE_PROGRAM:
    //   return { ...state, rebateProgram: Actions.payload };
    case ActionTypes.SET_MANUFACTURERS_LIST:
      return { ...state, manufacturerList: Actions.payload };
    case ActionTypes.GET_MANUFACTURER_NAME_ACT:
      return { ...state, allManufacturer: Actions.allManufacturer };
    case ActionTypes.DISPATCH_ALL_MFG_CHECKED:
      return { ...state, isMfgChecked: Actions.payload };
    case ActionTypes.GET_MANUFACTURER_ID_ACT:
      return { ...state, manufactureWithIds: Actions.manufactureWithIds };
    case ActionTypes.DISPLAY_URA_TYPE:
      return { ...state, uraType: Actions.payload };
    case ActionTypes.DISPATCH_QTR_VALUE:
      return { ...state, quarter: Actions.payload };
    case ActionTypes.SELECT_OPTION:
      return { ...state, selectedOption: Actions.payload };
    case ActionTypes.SET_REBATE_PROGRAM:
      return { ...state, setRebateProgram: Actions.payload };
    case ActionTypes.SET_DISPLAY_OBJ_MCO_CLAIMS:
      return { ...state, ...Actions.payload };
    case ActionTypes.SET_MCO_CLAIMS_DATA:
      let displayObj = {
        ...state.displayObj,
        searchResult: Actions.payload,
      };
      return { ...state, searchResult: Actions.payload, displayObj };
    case ActionTypes.REFRESH_MCO_CLAIMS:
      return { ...initialState, displayObj: state.displayObj };
    case ActionTypes.REFRESH_MCO_CLAIMS_DISPLAY:
      return { ...state, displayObj: initialState.displayObj };
    default:
      return state;
  }
};

export default reducer;
